import type { LeadTimeCalculatorInput } from '@calculations/lead-time/input';
import { extractWeeks } from '@calculations/lead-time/time';

import {
  ConstantValue,
  ConstantValueLeadTimeStrategy,
  ConstantValueLeadTimeStrategyResult,
} from './types';

export function runConstantValueStrategy(
  strategy: ConstantValueLeadTimeStrategy,
  _input: LeadTimeCalculatorInput,
): ConstantValueLeadTimeStrategyResult {
  return {
    name: ConstantValue,
    weeks: extractWeeks(strategy.config),
  };
}
